export enum Contrat {
    Cdd = "CDD",
    Cdi = "CDI",
    Alternance = "Alternance",
    Stage = "Stage",
    Interim = "Interim"

}